import React from 'react';
import { Flex, } from '@chakra-ui/react';
import HeaderSection from './HeaderSection';

const Mockup = ({
    children, setIsExample
}) => {
    return (
        <>
            <HeaderSection setIsExample={setIsExample} />
            <Flex
                alignItems={'center'}
                bg='#b9d1f0'
            >

                <Flex
                    flexDir="column"
                    overflow="hidden"
                    height="100%"
                    width="100%"
                >
                    {children?.content ? children.content : children}
                </Flex>

            </Flex >
            {/*Will be uncoment once we need this*/}
            {/* <ContactsBlock />. */}
        </>
    );
};

export default Mockup;
